import { Clock, MapPin, Phone, UtensilsCrossed } from "lucide-react";
import { ADDRESS, DIRECTIONS_URL, PHONE_DISPLAY, PHONE_TEL } from "./data";

const ITEMS = [
  {
    icon: MapPin,
    title: "Find Us",
    line: ADDRESS,
    href: DIRECTIONS_URL,
    action: "Get Directions",
    testid: "infobar-directions-link",
  },
  {
    icon: Phone,
    title: "Call Us",
    line: PHONE_DISPLAY,
    href: PHONE_TEL,
    action: "Tap to Call",
    testid: "infobar-call-link",
  },
  {
    icon: Clock,
    title: "Opening Hours",
    line: "Mon – Sun · from 4:30 PM",
    href: "#contact",
    action: "View Hours",
    testid: "infobar-hours-link",
  },
  {
    icon: UtensilsCrossed,
    title: "Dine-In, Takeaway & Delivery",
    line: "Order ahead, eat in or get it delivered",
    href: "#menu",
    action: "See Menu",
    testid: "infobar-menu-link",
  },
];

export default function InfoBar() {
  return (
    <section data-testid="info-bar-section" className="relative z-20 mx-auto -mt-16 max-w-6xl px-4 sm:px-6">
      <div className="card-glow grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#C97B5F]/15 bg-[#D4A359]/10 shadow-[0_20px_60px_rgba(0,0,0,0.6)] sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item) => (
          <a
            key={item.title}
            href={item.href}
            target={item.href.startsWith("http") ? "_blank" : undefined}
            rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
            data-testid={item.testid}
            className="group flex items-start gap-4 bg-white p-5 transition-colors duration-200 hover:bg-[#FAF5EC]"
          >
            <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#C97B5F]/30 bg-[#D4A359]/10 text-[#8A3324] transition-colors duration-200 group-hover:bg-[#D4A359]/20">
              <item.icon size={17} />
            </span>
            <span>
              <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-[#8A3324]">{item.title}</span>
              <span className="mt-1 block text-sm font-medium leading-snug text-[#2A211A]">{item.line}</span>
              <span className="mt-1.5 block text-xs text-stone-500 transition-colors duration-200 group-hover:text-[#E86A24]">
                {item.action} →
              </span>
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
